import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { CheckCircle } from 'lucide-react';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  if (isSuccess) {
    return <div className="bg-green-50 border border-green-200 rounded-xl p-8 text-center" data-id="element-25">
        <div className="flex justify-center mb-4" data-id="element-26">
          <CheckCircle className="h-12 w-12 text-green-600" data-id="element-27" />
        </div>
        <h3 className="text-xl font-semibold text-green-900 mb-2" data-id="element-28">
          Request Received
        </h3>
        <p className="text-green-800" data-id="element-29">
          Thank you for contacting DanyCredit. A specialist will review your
          information and contact you shortly to schedule your consultation.
        </p>
        <Button variant="outline" className="mt-6" onClick={() => setIsSuccess(false)} data-id="element-30">
          Send Another Request
        </Button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-4" data-id="element-31">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-32">
        <Input label="Full Name" placeholder="Jane Doe" required data-id="element-33" />
        <Input label="Email Address" type="email" placeholder="jane@example.com" required data-id="element-34" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-35">
        <Input label="Phone Number" type="tel" placeholder="(555) 123-4567" required data-id="element-36" />
        <Input label="State" placeholder="NY" required data-id="element-37" />
      </div>

      <div className="w-full" data-id="element-38">
        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-39">
          Primary Goal
        </label>
        <select className="flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-40">
          <option value="" data-id="element-41">Select a goal...</option>
          <option value="review" data-id="element-42">Credit Profile Review</option>
          <option value="education" data-id="element-43">General Credit Education</option>
          <option value="planning" data-id="element-44">Financial Planning</option>
          <option value="business" data-id="element-45">Business Credit Readiness</option>
        </select>
      </div>

      <div className="w-full" data-id="element-46">
        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-47">
          Preferred Contact Time
        </label>
        <select className="flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-48">
          <option value="morning" data-id="element-49">Morning (9AM - 12PM)</option>
          <option value="afternoon" data-id="element-50">Afternoon (12PM - 5PM)</option>
          <option value="evening" data-id="element-51">Evening (5PM - 7PM)</option>
        </select>
      </div>

      <div className="pt-2" data-id="element-52">
        <Button type="submit" className="w-full" size="lg" isLoading={isSubmitting} data-id="element-53">
          Request Consultation
        </Button>
        <p className="text-xs text-slate-500 mt-4 text-center" data-id="element-54">
          By submitting this form, you agree to our Privacy Policy. Your
          information is secure and confidential.
        </p>
      </div>
    </form>;
}